import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useGetAchieveRecommendQuery} from '../../../redux/myDynamicApi';
import Loader from '../../../assets/Animations/PreLoaderComponent/Loader';
import RecommendCard from './RecommendCard/RecommendCard';
import styles from './UserRecommended.module.css';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import {useStatusRestriction} from '../../../hooks/useStatusRestriction';

interface Props {}

const UserRecommended: React.FC<Props> = ({}) => {
	const {t} = useTranslation();
	const restrictions = useStatusRestriction();
	const {data: archiveRecommended, isLoading} = useGetAchieveRecommendQuery();
	if (isLoading) return <Loader />;
	if (archiveRecommended?.qlfc_name === 'GM') return null;
	return (
		<div className={styles.row}>
			<div className={styles.column}>
				{archiveRecommended && (
					<div className={styles.recommendCard}>
						<div className={`${styles.title}`}>
							{t('До наступної кваліфікації вам потрібно')}:
						</div>
						<div className={styles.swiperWrapper}>
							{/* Мобильная версия без Swiper */}
							<div className={styles.mobileCards}>
								{archiveRecommended.cards.map((card, index) => (
									<RecommendCard
										key={card.branch_id}
										card={card}
										isActive={index === 0}
									/>
								))}
							</div>
							{/* Десктопная версия с Swiper */}
							<div className={styles.desktopSwiper}>
								<Swiper
									spaceBetween={30}
									slidesPerView={2}
									breakpoints={{
										320: {slidesPerView: 1, spaceBetween: 10},
										480: {slidesPerView: 1, spaceBetween: 15},
										768: {slidesPerView: 2, spaceBetween: 20},
										1024: {slidesPerView: 2, spaceBetween: 30},
									}}
									className={styles.swiper}
									watchOverflow={true}
									observer={true}
									observeParents={true}
									allowTouchMove={true}
								>
									{archiveRecommended.cards.map((card, index) => (
										<SwiperSlide key={card.branch_id} className={styles.slide}>
											<RecommendCard card={card} isActive={index === 0} />
										</SwiperSlide>
									))}
								</Swiper>
							</div>
						</div>
					</div>
				)}
			</div>
			<div className={styles.column}>
				<div className={styles.body}>
					<div className={styles.top}>
						<div className={styles.topTitle}>
							{t('Найближча кваліфікація')}:
						</div>
						<div className={styles.mark}>{archiveRecommended?.qlfc_name}</div>
					</div>
					{restrictions.canShowMainDynamicLink && (
						<div className={styles.bottom}>
							<div className={styles.bottomItem}>
								<div className={styles.bottomItemLabel}>{t('Моя динаміка')}</div>
								<Link to="/my_dynamic" className="btn-main">
									{t('Дивитися')}
								</Link>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default UserRecommended;
